var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lottieAnimation",style:(_vm.style),on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }